var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 16.875V15.625H18.125V16.875H10.625ZM10.625 13.125V11.875H18.125V13.125H10.625ZM10.625 9.375V8.125H18.125V9.375H10.625ZM8.125 17.5C7.78125 17.5 7.48688 17.3775 7.24188 17.1325C6.99688 16.8875 6.87458 16.5933 6.875 16.25C6.875 15.9063 6.9975 15.6119 7.2425 15.3669C7.4875 15.1219 7.78167 14.9996 8.125 15C8.46875 15 8.76313 15.1225 9.00813 15.3675C9.25313 15.6125 9.37542 15.9067 9.375 16.25C9.375 16.5938 9.2525 16.8881 9.0075 17.1331C8.7625 17.3781 8.46833 17.5004 8.125 17.5ZM8.125 13.75C7.78125 13.75 7.48688 13.6275 7.24188 13.3825C6.99688 13.1375 6.87458 12.8433 6.875 12.5C6.875 12.1563 6.9975 11.8619 7.2425 11.6169C7.4875 11.3719 7.78167 11.2496 8.125 11.25C8.46875 11.25 8.76313 11.3725 9.00813 11.6175C9.25313 11.8625 9.37542 12.1567 9.375 12.5C9.375 12.8438 9.2525 13.1381 9.0075 13.3831C8.7625 13.6281 8.46833 13.7504 8.125 13.75ZM8.125 10C7.78125 10 7.48688 9.8775 7.24188 9.6325C6.99688 9.3875 6.87458 9.09333 6.875 8.75C6.875 8.40625 6.9975 8.11188 7.2425 7.86688C7.4875 7.62188 7.78167 7.49958 8.125 7.5C8.46875 7.5 8.76313 7.6225 9.00813 7.8675C9.25313 8.1125 9.37542 8.40667 9.375 8.75C9.375 9.09375 9.2525 9.38813 9.0075 9.63313C8.7625 9.87813 8.46833 10.0004 8.125 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalFilledIcon);
export default __webpack_public_path__ + "static/media/additional-filled-icon.e8797750c4775ca758e8213d8d053df9.svg";
export { ForwardRef as ReactComponent };